import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog__header flex align-items-center justify-content-between w-full" }
const _hoisted_2 = { class: "flex justify-content-end gap-2" }
const _hoisted_3 = { class: "ml-auto" }
const _hoisted_4 = { class: "flex w-full gap-1" }
const _hoisted_5 = ["textContent"]

import { ref, Ref, computed } from 'vue';
import DataTable, { DataTableFilterMeta } from 'primevue/datatable';
import { FilterMatchMode } from 'primevue/api';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';
import { useArrayUtilities } from '@/composables';
import AddStatesModal from './AddStatesModal.vue';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'StateTable',
  setup(__props, { emit: __emit }) {

const relayHubStore = useRelayHubStore();
const { selectedMedicaidStates, originalMedicaidStates, enabledStates, loading } = storeToRefs(relayHubStore);
const showAddStates = ref<boolean>(false);

const emit = __emit;

const selectedItems = ref<string[]>([]);

const openAddStates = () => (showAddStates.value = true);

const closeAddStates = () => (showAddStates.value = false);

const onCancel = async () => {
  emit(EMIT.RESET);
};

const onSave = async () => {
  await relayHubStore.saveStateMedicareAssignments();
  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('State Changes Saved');

  emit(EMIT.RESET);
};

const handleStatesAdded = () => {
  closeAddStates();
  emit(EMIT.RESET);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filter: Ref<any> = ref({
  global: { value: '', matchMode: FilterMatchMode.CONTAINS },
  name: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
} as DataTableFilterMeta);

const shouldDisable = computed(() =>
  useArrayUtilities().twoNumericArraysContainSameData(selectedMedicaidStates.value, originalMedicaidStates.value),
);

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "page-content-full" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "States", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppButton, {
              type: "text",
              size: "small",
              text: "Add States",
              "icon-left": "add",
              onClick: openAddStates
            })
          ])
        ])
      ])
    ]),
    content: _withCtx(() => [
      (showAddStates.value)
        ? (_openBlock(), _createBlock(AddStatesModal, {
            key: 0,
            onCancel: closeAddStates,
            onSave: handleStatesAdded
          }))
        : _createCommentVNode("", true),
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 1,
            class: "flex justify-content-center align-items-center h-full loader"
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(DataTable), {
        filters: filter.value,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((filter).value = $event)),
        selection: selectedItems.value,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((selectedItems).value = $event)),
        "global-filter-fields": ['name'],
        scrollable: true,
        value: _unref(enabledStates),
        "data-key": "name",
        "responsive-layout": "scroll",
        "scroll-height": "flex",
        style: { maxHeight: '600px' }
      }, {
        empty: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("There are no States connected", -1)
        ]))]),
        default: _withCtx(() => [
          (_unref(enabledStates)?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_Column, { class: "text-center justify-content-center px-3" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Checkbox, {
                      modelValue: _unref(selectedMedicaidStates),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedMedicaidStates) ? (selectedMedicaidStates).value = $event : null)),
                      name: slotProps.data.name,
                      value: slotProps.data.id
                    }, null, 8, ["modelValue", "name", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "name",
                  sortable: "",
                  header: "Name",
                  style: {
              minWidth: '88%',
            }
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        textContent: _toDisplayString(slotProps.data.name)
                      }, null, 8, _hoisted_5)
                    ])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["filters", "selection", "value"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        disabled: shouldDisable.value,
        onClick: onCancel
      }, null, 8, ["disabled"]),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        disabled: shouldDisable.value,
        onClick: onSave
      }, null, 8, ["disabled"])
    ]),
    _: 1
  }))
}
}

})